import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "formContainer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-3 mb-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!
  const _component_scope_1_activity_recorder = _resolveComponent("scope-1-activity-recorder")!
  const _component_scope_2_activity_recorder = _resolveComponent("scope-2-activity-recorder")!
  const _component_travel_logistic_mobility_activity_recorder = _resolveComponent("travel-logistic-mobility-activity-recorder")!
  const _component_spending_activity_recorder = _resolveComponent("spending-activity-recorder")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Activity data recorder",
        text: "Activity data recorder",
        class: "mb-0"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_form_field, {
        type: "select-string",
        list: _ctx.scopesList,
        modelValue: _ctx.selectedScope,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedScope) = $event)),
        labelKey: 'Scope',
        labelValue: 'Scope',
        placeholderKey: "Select a scope",
        placeholderValue: "Select a scope"
      }, null, 8, ["list", "modelValue"]),
      _hoisted_3,
      (_ctx.selectedScope == _ctx.viewModel.ScopesActivityRecorder.Scope1)
        ? (_openBlock(), _createBlock(_component_scope_1_activity_recorder, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.selectedScope == _ctx.viewModel.ScopesActivityRecorder.Scope2)
        ? (_openBlock(), _createBlock(_component_scope_2_activity_recorder, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.selectedScope == _ctx.viewModel.ScopesActivityRecorder.TravelLogisticMobility)
        ? (_openBlock(), _createBlock(_component_travel_logistic_mobility_activity_recorder, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.selectedScope == _ctx.viewModel.ScopesActivityRecorder.Spending)
        ? (_openBlock(), _createBlock(_component_spending_activity_recorder, { key: 3 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}